import React from 'react';

import { Dropdown } from 'react-bootstrap';

// Temporary workaround to fix the issue that dropdowns do not open with React v17
// https://github.com/react-bootstrap/react-bootstrap/issues/5561
export const DropdownWrapper = ({
  align,
  className,
  children,
}: {
  align?: 'start' | 'end';
  className?: string;
  children: any;
}) => {
  return (
    <Dropdown align={align} className={className} onClick={(e: any) => e.stopPropagation()}>
      {children}
    </Dropdown>
  );
};
